import { LicenceDto } from "@libs/api/gateways/plt/plt-gateway.dtos";

import { LicenceFormValues } from "./LicenceFormDialog.types";

export const getLicenceFormValues = (dto: LicenceDto): LicenceFormValues => {
  let expiryDate: Date | undefined;

  if (dto.expiryDate) {
    const dt = new Date(dto.expiryDate);

    const isLocalMidnight =
      dt.getHours() === 0 && dt.getMinutes() === 0 && dt.getSeconds() === 0;

    // Old data may have been set to 12:00:00 this adjusts it to work with the form
    // new data going forward will be 11:59:59 instead
    if (isLocalMidnight) {
      dt.setDate(dt.getDate() - 1);
    }

    expiryDate = dt;
  }

  return {
    productId: dto.productId,
    userId: dto.userId,
    username: dto.username,
    expiryDate,
    isActive: !dto.isInactive,
    licenceTypeCode: dto.licenceTypeCode,
    name: dto.name,
    displayName: dto.displayName,
    description: dto.description,
    doNotRenew: dto.doNotRenew,
    source: dto.source ?? "MANUAL"
  };
};
